export default function getColorBrightness(color) {
  let r, g, b;
  if ("#" == color[0] && 7 == color.length) {
    r = parseInt(color.slice(1, 3), 16);
    g = parseInt(color.slice(3, 5), 16);
    b = parseInt(color.slice(5, 7), 16);
  } else if ("#" == color[0] && 4 == color.length) {
    r = parseInt(color[1] + color[1], 16);
    g = parseInt(color[2] + color[2], 16);
    b = parseInt(color[3] + color[3], 16);
  }

  return (r + r + b + g + g + g) / 6;
}

export function isLightColor(color) {
  return getColorBrightness(color) > 200;
}
